import styled from "styled-components"
import { Link } from "react-router-dom"

/*carefull*/
interface MenuProps {
  isOpen: boolean;
}

export const Nav = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background: #46C6CC;
`

export const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span{
    height: 2px;
    width: 25px;
    background: #29201e;
    margin-bottom: 4px;
    color:black;
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`

export const MenuLink = styled(Link)`
  padding: 1rem 2rem;
  color: #29201e;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: all 0.3s ease-in;
  font-size: 1.5rem;

  &:hover {
    color: #FFFFFF;
  }
`
/*carefull*/
export const Menu = styled.div<MenuProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    overflow: hidden;
    flex-direction: column;
    width: 100%;
    max-height: ${({ isOpen }) => (isOpen ? "300px" : "0")};
    transition: max-height 0.3s ease-in;
  }
`

export const Logo = styled(Link)`
  color: #29201e;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.7rem;
  transition: all 0.3s ease-in;

  img {
    width: 64px;
  }

  &:hover {
    color: #FFFFFF;
  }
`